module.exports = require('./helpers/bundle-url').getBundleURL('1G2bZ') + "login-t-logo.2469f406.svg" + "?" + Date.now();